var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBirthday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.8 44.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231916;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\uC790\uC0B0 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.7,22.4H.7A.7.7,0,1,1,.7,21h3a.7.7,0,1,1,0,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.6,10.2,8.1,10,4.7,6.6a.9.9,0,0,1,0-1,.9.9,0,0,1,1,0L9.1,9a.7.7,0,0,1,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.9,10.2l-.5-.2a.7.7,0,0,1,0-1l3.4-3.4a.8.8,0,0,1,.9,0,.7.7,0,0,1,0,1L33.3,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.1,22.4h-3a.7.7,0,1,1,0-1.4h3a.7.7,0,1,1,0,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.8,5.2a.8.8,0,0,1-.7-.7v-3a.7.7,0,1,1,1.4,0v3A.8.8,0,0,1,20.8,5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.2,13.1A.8.8,0,0,1,3,14a.8.8,0,0,1-.8.8.8.8,0,0,1-.8-.8.8.8,0,0,1,.8-.9m0-1.3A2.2,2.2,0,0,0,0,14a2.2,2.2,0,0,0,2.2,2.2A2.2,2.2,0,0,0,4.4,14a2.2,2.2,0,0,0-2.2-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.6,1.6A1.4,1.4,0,0,1,30,3a1.3,1.3,0,0,1-1.4,1.3A1.3,1.3,0,0,1,27.3,3a1.3,1.3,0,0,1,1.3-1.4m0-1.5A2.9,2.9,0,0,0,25.8,3a2.9,2.9,0,0,0,5.7,0A2.9,2.9,0,0,0,28.6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.2,2.2a.8.8,0,0,1-.8-.7V.8a.8.8,0,0,1,.8-.8.7.7,0,0,1,.7.8v.7A.7.7,0,0,1,13.2,2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.2,6a.9.9,0,0,1-.8-.8V4.5a.8.8,0,0,1,.8-.8.7.7,0,0,1,.7.8v.7A.8.8,0,0,1,13.2,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.4,3.7h-.7a.7.7,0,0,1-.8-.7.8.8,0,0,1,.8-.8h.7a.9.9,0,0,1,.8.8A.8.8,0,0,1,15.4,3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.7,3.7h-.8a.7.7,0,0,1-.7-.7.8.8,0,0,1,.7-.8h.8a.8.8,0,0,1,.7.8A.7.7,0,0,1,11.7,3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.4,13.7l-.6-.3a.9.9,0,0,1,0-1l.6-.5a.7.7,0,0,1,1,1l-.5.5A.5.5,0,0,1,40.4,13.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.8,16.3l-.6-.2a.8.8,0,0,1,0-1.1l.5-.5a.8.8,0,0,1,1.1,1.1l-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.9,16.3l-.5-.2-.6-.5a1.1,1.1,0,0,1,0-1.1.8.8,0,0,1,1.1,0l.5.5a.8.8,0,0,1,0,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.3,13.7a.9.9,0,0,1-.6-.3l-.5-.5a.7.7,0,0,1,0-1,.8.8,0,0,1,1.1,0l.5.5a.7.7,0,0,1,0,1A.5.5,0,0,1,38.3,13.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.5,43.4V30.7h-3V21.3H29.8v-2A2.6,2.6,0,0,0,32,16.4c0-1.3-1.1-2.7-2.9-4.6,0,0-2.8,2.1-2.8,4.5s.7,2.8,2.3,3v2H21.5V19.1a3,3,0,0,0,2.7-3.3c0-1.5-1.3-3.1-3.3-5.3,0,0-3.2,2.5-3.2,5.1s.8,3.2,2.6,3.5v2.2h-7v-2a2.7,2.7,0,0,0,2.3-2.9c0-1.3-1.1-2.7-3-4.6,0,0-2.7,2.1-2.7,4.5s.7,2.8,2.2,3v2H8.3v9.4H5.1V43.4H3.6v1.5H38.1V43.4ZM27.6,16.3A5.3,5.3,0,0,1,29,13.5c1,1.1,1.8,2.2,1.8,2.9s-1.1,1.7-1.5,1.7S27.6,17.9,27.6,16.3Zm-8.5-.7c0-1,.9-2.2,1.7-3.1,1.1,1.2,2,2.5,2,3.3s-1.3,1.9-1.7,1.9S19.1,17.5,19.1,15.6Zm-8,.7a4.9,4.9,0,0,1,1.5-2.8c.9,1.1,1.7,2.2,1.7,2.9s-1.1,1.7-1.4,1.7S11.1,17.9,11.1,16.3ZM9.5,27.2A6.1,6.1,0,0,1,11.7,26a7.9,7.9,0,0,1,2,1.2,6.1,6.1,0,0,0,2.6,1.3,4.7,4.7,0,0,0,2.4-1.2A7.7,7.7,0,0,1,20.9,26,7.5,7.5,0,0,1,23,27.3c1.1.8,1.7,1.2,2.4,1.2s1.3-.5,2.5-1.3A6.3,6.3,0,0,1,29.8,26a3.4,3.4,0,0,1,1.4.8,6,6,0,0,0,1.1.6v3.3H9.5ZM6.7,43.4V37.5a4.8,4.8,0,0,0,2.2,1.2c.5,0,1-.4,1.9-1.1A6.1,6.1,0,0,1,13,36.4c.4,0,1,.5,1.6,1a4.2,4.2,0,0,0,2.3,1.3,3.4,3.4,0,0,0,2.2-1.3,3.7,3.7,0,0,1,1.8-1c.5,0,1.2.6,1.8,1.1a3.8,3.8,0,0,0,2.1,1.2,3.9,3.9,0,0,0,1.9-1,4.8,4.8,0,0,1,2.1-1.1c.6,0,1.1.5,1.6.9a3.2,3.2,0,0,0,2.2,1.2,3.4,3.4,0,0,0,2.3-1.3H35v6.1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirthday);
export default __webpack_public_path__ + "static/media/birthday.aec4b22f28fd8f75347418a899335e3b.svg";
export { ForwardRef as ReactComponent };